module.exports = __webpack_public_path__ + "static/media/arrow_right.91576f3b.svg";